import styled from 'styled-components';

export const RailContent = styled.div`
  display: flex;
  flex-direction: column;

  &[hidden] {
    display: none;
  }
`;

// As tall as the open rail's header, so the arrow keeps its row when the rail folds.
export const RailStrip = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  min-height: 48px;
  background: ${({ theme }) => theme.colors.surfaceContainer};
  border-bottom: 1px solid ${({ theme }) => theme.colors.outlineVariant};
`;
